import type { ProductVariation } from "@/lib/products-info";

export type GbTier = {
  gb: number;
  monthlyPPG: number;
  totalPrice: number;
  productId?: string;
  variationId?: string;
};

export function buildGbTiers(raw: ProductVariation[], fallback: GbTier[]): GbTier[] {
  if (!raw.length) return fallback;
  return raw.map((t) => {
    const total = parseFloat(t.price);
    return {
      gb: t.value,
      monthlyPPG: Math.round((total / t.value) * 100) / 100,
      totalPrice: total,
      productId: t.product_id,
      variationId: t.variation_id,
    };
  });
}
